import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@chakra-ui/react";
const TabsContainer = (props) => {
    const { children } = props;
    return (_jsx(Box, { mt: { base: "10px", sm: "20px" }, mb: { base: "10px", sm: "20px" }, children: children }));
};
export default TabsContainer;
//# sourceMappingURL=tabsContainer.js.map